import { render } from "./SideNavDrawer.vue?vue&type=template&id=57ca8cc5"
import script from "./SideNavDrawer.vue?vue&type=script&lang=js"
export * from "./SideNavDrawer.vue?vue&type=script&lang=js"

import "./SideNavDrawer.vue?vue&type=style&index=0&id=57ca8cc5&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__